/**
 * De copilootkolom, op elke pagina (sessie 46, B6).
 *
 * Tot sessie 46 werkte de copiloot alleen op een zaak op Vandaag; op de
 * andere schermen stond "De copiloot werkt op een zaak". Nu leest hij
 * wat er in beeld is uit `kijktMee`: een kaart, een klant, een retour,
 * een review, of de pagina zelf. Het gesprek blijft één gesprek.
 *
 * De prop `zaakId` blijft bestaan voor Vandaag: de gekozen kaart wint
 * van de URL (bijschaven 22-09), en de URL is de terugval.
 */
import { useSearchParams } from "react-router-dom";

import { useKijkContext } from "./kijktMee";
import { WerkplekCopiloot } from "./WerkplekCopiloot";

import "./copiloot.css";

/** Ruwe UUID-vorm; een onzinwaarde in de URL mag geen 422 uitlokken. */
const UUID_VORM =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

interface Props {
  /** De kaart die openstaat. Wint van de context en van de URL. */
  zaakId?: string | null;
}

export function WerkplekCopilootKolom({ zaakId }: Props = {}) {
  const [params] = useSearchParams();
  const context = useKijkContext();
  const uitUrl = params.get("zaak");
  const gekozen = zaakId ?? (context.soort === "pagina" ? uitUrl : null);

  const effectief =
    gekozen && UUID_VORM.test(gekozen)
      ? { soort: "zaak" as const, id: gekozen }
      : context;

  return <WerkplekCopiloot context={effectief} />;
}
